import { useParams } from 'react-router';

export const useVerifierParamId = () => {
  const { verifierId } = useParams<{ verifierId: string }>();
  return verifierId;
};
